module.exports = __webpack_public_path__ + "img/is.262b99a3.svg";